"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolePermissionMap = void 0;
var Role_1 = require("./Role");
var UserPermissions_1 = require("./users/UserPermissions");
exports.RolePermissionMap = (_a = {},
    _a[Role_1.Role.Admin] = __spreadArray([], UserPermissions_1.userPermissionMap[Role_1.Role.Admin]),
    _a[Role_1.Role.User] = __spreadArray([], UserPermissions_1.userPermissionMap[Role_1.Role.User]),
    _a);
//# sourceMappingURL=RolePermissionMap.js.map